import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var PASSWORD_REPLACEMENT = '******';
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
export default {
  name: 'CoreTenantBridgeConfigField',
  props: {
    bridgeType: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    fieldConfig: {
      // type: Object,
      required: true
    },
    bridgeManifest: {
      type: Object,
      required: true
    },
    // the corresponding config-parameters for the bridge (NOT the bridge-config-object!)
    bridgeConfig: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    bridgeConfigId: {
      type: Number,
      required: false,
      default: null
    },
    configKey: {
      type: String,
      required: true
    },
    isCreatedByTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: false,
      default: function _default() {
        return undefined;
      }
    },
    bridgeHasValidParameters: {
      type: Boolean,
      required: true,
      default: true
    },
    bridgeHasValidParametersStrict: {
      type: Boolean,
      required: true
    },
    defaultIcon: {
      type: String,
      required: false,
      default: function _default() {
        return '';
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    // eslint-disable-next-line vue/require-prop-types
    dependsOnFieldValue: {
      required: false,
      default: null
    },
    // code that used this is commented out, remove it works fine without it
    // bridgeValidations: {
    //   type: Object,
    //   required: false,
    //   default: () => ({}),
    // },
    brigdeHasError: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: function data() {
    return {
      v: undefined,
      showPassword: false,
      autoCompleteItems: [],
      search: null,
      debouncedRequestAutoComplete: debounce(this.requestAutoComplete, 300),
      // see `updated` hook for filling stuff initially
      initialUpdate: false,
      emptyCustomHeaders: false,
      openHelpText: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    hasPrependIcon: function hasPrependIcon() {
      if (!this.bridgeHasValidParameters && this.isBrigdeHasError) {
        // enum and autocomplete never check for optional in prepend-inner template
        if (this.fieldConfig.type === 'enum' || this.fieldConfig.autocomplete) {
          return true;
        }

        return !!this.fieldConfig.optional ? false : true;
      } else if (this.bridgeHasValidParametersStrict) {
        return true;
      } else if (this.defaultIcon) {
        return true;
      }

      return false;
    },
    helpTextKey: function helpTextKey() {
      return "Bridges.quickReferences.BRIDGE-".concat(this.bridgeType.replace(/^bridge-/, ''), ".fieldHelp.").concat(this.configKey);
    },
    hasHelpText: function hasHelpText() {
      return this.$i18n_te(this.helpTextKey);
    },
    fieldLabel: function fieldLabel() {
      return this.fieldConfig.name || this.configKey;
    },
    fieldConfigStringField: function fieldConfigStringField() {
      return get(this.fieldConfig, 'stringOptions.field') || '';
    },
    isValidPassword: function isValidPassword() {
      return this.fieldConfigStringField === 'password' && this.v !== PASSWORD_REPLACEMENT;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      };
    },
    emailRule: function emailRule() {
      var _this2 = this;

      return function (v) {
        return !v || /.+@.+\.[a-z]+/.test(v) || _this2.$i18n_t('Common.emailValid');
      };
    },
    detailsMode: function detailsMode() {
      return this.bridgeHasValidParameters === true ? 'auto' : false;
    },
    textFieldAppendIcon: function textFieldAppendIcon() {
      if (this.fieldConfigStringField === 'password') {
        return this.isValidPassword ? this.showPassword ? 'fal fa-eye' : 'fal fa-eye-slash' : undefined;
      }

      if (this.fieldConfigStringField === 'eui') {
        return 'fal fa-pen';
      }

      return undefined;
    },
    enumItems: function enumItems() {
      var _this3 = this;

      if (this.fieldConfig.type === 'enum') {
        if (this.fieldConfig.outputValues && _typeof(this.fieldConfig.outputValues) === 'object') {
          var items = [];
          Object.keys(this.fieldConfig.outputValues).forEach(function (key) {
            items.push({
              text: _this3.fieldConfig.outputValues[key],
              value: key
            });
          });
          return items;
        }
      }

      return this.fieldConfig.values;
    },
    keyValueItems: function keyValueItems() {
      if (this.fieldConfig.type === 'jsonkeyvalue') {
        var items = [];

        if (typeof this.value === 'string') {
          items = Object.entries(JSON.parse(this.value));
        }

        return items;
      }

      return [['', '']];
    },
    // was not used anywhere, remove it it works out fine without it
    // isBridgeValidationsEmpty() {
    //   return Object.keys(this.bridgeValidations).length === 0;
    // },
    isBrigdeHasError: function isBrigdeHasError() {
      return this.brigdeHasError;
    }
  }),
  watch: {
    value: function value() {
      this.v = this.value;

      if (this.fieldConfig.type === 'object') {
        if (get(this.v, 'text') === undefined || get(this.v, 'value') === undefined) {
          try {
            this.v = JSON.stringify(this.v);
          } catch (_) {
            return;
          }
        }
      }
    },
    search: function search(val) {
      if (this.fieldConfig.dependsOnField) {
        // skip onSearch, it is triggered by other field value change
        return;
      }

      val && val !== this.value && this.debouncedRequestAutoComplete(val, this);
    },
    dependsOnFieldValue: function dependsOnFieldValue(val) {
      if (val && this.fieldConfig.autocomplete) {
        this.debouncedRequestAutoComplete(val, this);
      }
    }
  },
  // for newly created config-fields (aka new bridge-instances) the "mounted" hook does not seem to trigger
  // so update the values within the `updated` hook, which is called more often, but we only care about
  // the initial time when this.v is undefined for configuring default data
  updated: function updated() {
    this.$nextTick(function () {
      if (this.initialUpdate) {
        return;
      }

      this.initialUpdate = true;
      this.v = this.value;

      if (this.v === undefined) {
        this.v = this.fieldConfig.default;

        if (this.v) {
          this.modelChanged();
        }
      }

      if (this.v === undefined && this.fieldConfig.fallbackConfigValue) {
        this.v = get(this.bridgeConfig, this.fieldConfig.fallbackConfigValue);

        if (this.v) {
          this.modelChanged();
        }
      }

      if (this.fieldConfig.autocomplete) {
        var searchValue = this.v;

        if (this.fieldConfig.dependsOnField) {
          searchValue = this.dependsOnFieldValue;
        }

        this.debouncedRequestAutoComplete(get(searchValue, 'text', searchValue), this);
      }
    });
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.v = this.value;

      if (this.v === undefined) {
        this.v = this.fieldConfig.default;

        if (this.v) {
          this.modelChanged();
        }
      }

      if (this.v === undefined && this.fieldConfig.fallbackConfigValue) {
        this.v = get(this.bridgeConfig, this.fieldConfig.fallbackConfigValue);

        if (this.v) {
          this.modelChanged();
        }
      }

      if (this.fieldConfig.autocomplete) {
        var searchValue = this.v;

        if (this.fieldConfig.dependsOnField) {
          searchValue = this.dependsOnFieldValue;
        }

        this.debouncedRequestAutoComplete(get(searchValue, 'text', searchValue), this);
      }

      if (this.fieldConfig.type === 'jsonkeyvalue') {
        if (!this.value || this.value === '{}') {
          this.emptyCustomHeaders = true;
        }
      }
    });
  },
  methods: {
    get: get,
    euiRule: function euiRule() {
      var _this4 = this;

      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
      return function (v) {
        var regExp = new RegExp("^([0-9A-F]{".concat(length, "})$"), 'gi');
        var result = regExp.exec((v || '').trim());
        return result !== null || _this4.$i18n_tc('DigitalTwin.DigitalTwin.copy.euiRule', length * 4, {
          n: length * 4
        });
      };
    },
    rulesForField: function rulesForField(config) {
      var rules = [];

      if (!config.optional && this.isBrigdeHasError) {
        rules.push(this.requiredRule);
      }

      if (config.type === 'string' && get(config, 'stringOptions.field') === 'email') {
        rules.push(this.emailRule);
      }

      if (config.type === 'string' && get(config, 'stringOptions.field') === 'eui') {
        rules.push(this.euiRule(get(config, 'stringOptions.euiLength')));
      }

      return rules;
    },
    canBeStringified: function canBeStringified(obj) {
      try {
        JSON.stringify(obj);
        return true;
      } catch (e) {
        return false;
      }
    },
    modelChanged: function modelChanged() {
      // this bad boy has some history..
      // check out TWIN-682 (now RD-2817, MR 424)
      // and RD-6292 if there are any problems;
      // reworked because sometimes we are trying to
      // convert an object with a circular structure into JSON
      if (this.fieldConfig.type === 'number') {
        this.v = parseFloat(this.v);
      } else if (this.fieldConfig.type === 'object') {
        if (typeof this.v === 'string') {
          try {
            this.v = JSON.parse(this.v);
          } catch (_) {
            return; // If parsing fails, just return
          }
        } else if (!this.canBeStringified(this.v)) {
          return; // Exit if this.v cannot be stringified
        }
      } else if (this.fieldConfigStringField === 'password') {
        if (this.v === '') {
          return; // If password field is empty, just return
        }
      }

      if (typeof this.v === 'string') {
        if (get(this.fieldConfig, 'stringOptions.lowerCase') === true) {
          this.v = "".concat(this.v).toLowerCase();
        }

        if (get(this.fieldConfig, 'stringOptions.upperCase') === true) {
          this.v = "".concat(this.v).toUpperCase();
        }

        if (get(this.fieldConfig, 'stringOptions.trim') === true) {
          this.v = "".concat(this.v).trim();
        }
      }

      if (this.fieldConfig.type === 'jsonkeyvalue') {
        this.updateValueForJson();
      }

      this.$emit('input', this.v);
      this.$emit('changedBridgeParams');
    },
    textFieldClicked: function textFieldClicked(appendIcon) {
      if (this.fieldConfigStringField === 'password' && this.v === PASSWORD_REPLACEMENT) {
        this.v = '';
      }

      if (appendIcon) {
        if (this.fieldConfigStringField === 'password') {
          this.showPassword = !this.showPassword;
        }

        if (this.fieldConfigStringField === 'eui') {
          this.randomEui(get(this.fieldConfig, 'stringOptions.euiLength'));
        }
      }
    },
    randomEui: function randomEui(len) {
      this.v = this.randomHexString(len);
      this.modelChanged();
    },
    randomHexString: function randomHexString(len) {
      var charSet = 'ABCDEF0123456789';
      var randomString = '';

      for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
      }

      return randomString;
    },
    textFieldBlurred: function textFieldBlurred() {
      if (this.fieldConfigStringField === 'password' && this.v === '') {
        this.v = PASSWORD_REPLACEMENT;
        this.showPassword = false;
      }
    },
    requestAutoComplete: function requestAutoComplete(searchItem, instance) {
      var bridgeConfigManifest = instance.bridgeManifest;
      var configParam = instance.fieldConfig;
      var minLength = get(configParam, 'autocompleteConfig.minLength', 3);

      if (minLength <= 0 || searchItem && "".concat(searchItem).length >= minLength) {
        var isInstanceCommand = get(configParam, 'autocompleteConfig.instanceMethod');
        var command = configParam.autocomplete;
        var parameterNames = Object.keys(get(bridgeConfigManifest, "commands.".concat(isInstanceCommand ? 'instance' : 'static', ".").concat(command, ".parameters"), {}));
        var parameters = {};

        if (parameterNames.length >= 1) {
          parameters[parameterNames[0]] = searchItem;
        }

        if (isInstanceCommand) {
          return ApiService.bridgeCommand(instance.bridgeConfigId, command, parameters).then(function (result) {
            if (!result.error && result.data) {
              instance.autoCompleteItems = cloneDeep(result.data);
            }
          });
        }

        return ApiService.staticBridgeCommand(instance.bridgeType, command, parameters).then(function (result) {
          if (!result.error && result.data) {
            instance.autoCompleteItems = cloneDeep(result.data);
          }
        });
      }
    },
    addKeyValuePair: function addKeyValuePair(index) {
      this.keyValueItems.splice(index + 1, 0, ['', '']);
      this.$forceUpdate();
    },
    removeKeyValuePair: function removeKeyValuePair(index) {
      this.keyValueItems.splice(index, 1);
      this.$forceUpdate();
    },
    updateKeyValuePair: function updateKeyValuePair(index, newValue, type) {
      if (type === 'key') {
        this.keyValueItems[index][0] = newValue;
      } else if (type === 'value') {
        this.keyValueItems[index][1] = newValue;
      }

      this.$forceUpdate();
    },
    updateValueForJson: function updateValueForJson() {
      if (!this.keyValueItems || this.keyValueItems.length === 0) {
        this.emptyCustomHeaders = true;
      }

      this.v = JSON.stringify(Object.fromEntries(this.keyValueItems));
    },
    initCustomHeaders: function initCustomHeaders() {
      if (this.keyValueItems.length === 0) {
        this.keyValueItems.push(['', '']);
        this.emptyCustomHeaders = false;
        this.$forceUpdate();
      }
    }
  }
};